﻿import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms'; //required for 2way databinding
import { HttpModule, RequestOptions } from '@angular/http';


//3rd party libraries
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WjCoreModule, WjComponentLoader } from 'wijmo/wijmo.angular2.core';
import { WjGridModule } from 'wijmo/wijmo.angular2.grid';
import { WjInputModule } from 'wijmo/wijmo.angular2.input';

//import app modules + services
import { SharedModule } from './shared/shared.module';
import { AuthGuard } from './shared/security/auth-guard.service';


//app components
//import { HomeComponent } from './home/home.component';
import { SurveyComponent} from './survey/survey.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';


const appRoutes: Routes = [
   
    //misc routes
    {
        path: 'EchrContactForm/English/:surveyID',
        component: SurveyComponent,
    },
    {
        path: 'EchrContactForm/French/:surveyID',
        component: SurveyComponent,
    },
    {

        path: 'EchrContactForm/preview/:surveyID',
        component: SurveyComponent,
        //canActivate: [AuthGuard],
        //data: { roles: ['User'], breadcrumb: 'home' }
    },
   
    {
        path: '401',
        component: UnauthorizedComponent,
    },
    {
        path: '**',
        component: UnauthorizedComponent,
      
    },
];

@NgModule({
    declarations: [
        UnauthorizedComponent,
    ],
    providers: [
        //add services here
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
    ],
    exports: [
        RouterModule,

    ]
})
export class AppRoutingModule { }